import React, { createContext, useState, useContext, ReactNode } from 'react';
// Fix: Import KycData from types
import { KycData } from '../types';

interface KycContextType {
    kycData: KycData;
    updateKycData: (data: Partial<KycData>) => void;
    resetKycData: () => void;
}

export const KycContext = createContext<KycContextType | undefined>(undefined);

export const KycProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [kycData, setKycData] = useState<KycData>({});

    const updateKycData = (data: Partial<KycData>) => {
        setKycData(prev => ({ ...prev, ...data }));
    };

    const resetKycData = () => {
        setKycData({});
    };

    return (
        <KycContext.Provider value={{ kycData, updateKycData, resetKycData }}>
            {children}
        </KycContext.Provider>
    );
};

export const useKyc = () => {
    const context = useContext(KycContext);
    if (context === undefined) {
        throw new Error('useKyc must be used within a KycProvider');
    }
    return context;
};